import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormInput from '../../../components/form/FormInput';
import {
  modulePermissionAdd,
  modulePermissionUpdate
} from '../../../store/slices/adminSlices/modulePermissionSlice';

const AddEditModulePermissionModal = ({
  isOpen,
  onCloseClick,
  isEdit = false,
  editRecord = null
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    module_name: '',
    permissions: JSON.stringify({
      is_add: false,
      is_view: false,
      is_edit: false,
      is_delete: false,
      is_export: false,
      is_import: false
    })
  };

  const validationSchema = Yup.object({
    module_name: Yup.string().required('Module Name is required'),
    permissions: Yup.string().required('Permissions is required')
  });

  const onSubmit = async () => {
    if (isEdit) {
      try {
        const payload = { ...values, id: editRecord.id };
        payload['permissions'] = JSON.parse(values?.permissions);
        const response = await dispatch(modulePermissionUpdate(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Updated Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    } else {
      try {
        const payload = { ...values };
        payload['permissions'] = JSON.parse(values?.permissions);
        const response = await dispatch(modulePermissionAdd(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Added Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setValues
    // setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...editRecord,
        permissions: JSON.stringify(editRecord?.permissions)
      });
    }
  }, [editRecord]);

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{isEdit ? 'Edit Module Permission' : 'Add Module Permission'}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="modulePermission" onSubmit={handleSubmit}>
          <Row>
            <Col lg="3">
              <FormInput
                name="module_name"
                label="Module Name"
                placeholder="Enter Module Name"
                value={values.module_name}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="9">
              <FormInput
                name="permissions"
                label="Permissions"
                placeholder="Enter Permissions"
                value={values.permissions}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="modulePermission" type="submit" className="px-5 bg-primary border-primary">
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditModulePermissionModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditModulePermissionModal;
